import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";

import { FilterCompleteService } from "src/app/filter-complete/filter-complete";
import { DiagnosticFilter } from "src/app/model/diagnostic-filter";
import { MedicalAppointmentOrderAuditing } from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing";
import { MedicalAppointmentOrderAuditingUpdate } from "src/app/model/medical-appointment-auditing/medical-appointment-order-auditing-update";
import { DiagnosticService } from "src/app/services/diagnostic.service";

@Component({
  selector: "app-medical-appointment-order-auditing",
  templateUrl: "./medical-appointment-order-auditing.component.html",
  styleUrls: ["./medical-appointment-order-auditing.component.css"],
})
export class MedicalAppointmentOrderAuditingComponent implements OnInit {
  @Input() data: MedicalAppointmentOrderAuditing;
  @Output() dataChange: EventEmitter<MedicalAppointmentOrderAuditingUpdate> =
    new EventEmitter<MedicalAppointmentOrderAuditingUpdate>();

  mask: string = "";
  validityDays = "";
  athorizationValidity: boolean;
  requiredPreAuth: boolean;
  requiredDiagnosis: boolean;
  requiredCredentian: boolean;
  showMaskTyped: boolean = true;
  formGroup: FormGroup;
  loaded = false;
  filterCompleteautDiagnosisCIE: FilterCompleteService<DiagnosticFilter>;
  allDiagnosis: DiagnosticFilter[] = [];

  constructor(
    private fb: FormBuilder,
    private diagnosticService: DiagnosticService
  ) {
    this.formGroup = this.fb.group({
      ReferringPhysician: [""],
      ReferringPhysicianInstitute: [""],
      MemberNumber: [""],
      PreAuthorizationNumber: [""],
      Diagnostic: [null],
      OrderDate: [null],
      Observations: [""],
      OrderId: [null],
    });

    this.filterCompleteautDiagnosisCIE =
      new FilterCompleteService<DiagnosticFilter>(
        [],
        this.formGroup.controls.Diagnostic
      );
  }

  get filteredDiagnosesCIEOptions() {
    return this.filterCompleteautDiagnosisCIE
      ? this.filterCompleteautDiagnosisCIE.filteredOptions
      : [];
  }

  async ngOnInit() {
    this.allDiagnosis = await this.diagnosticService.getDiagnosticsFilter();

    this.filterCompleteautDiagnosisCIE =
      new FilterCompleteService<DiagnosticFilter>(
        this.allDiagnosis,
        this.formGroup.controls.Diagnostic
      );

    this.formGroup.patchValue(this.data);
    this.mask = this.data.OrderConf.Mask;
    this.requiredPreAuth = this.data.OrderConf.RequiredPreAuth;
    this.requiredDiagnosis = this.data.OrderConf.RequiredCIEDiagnosis;
    this.requiredCredentian = this.data.OrderConf.RequiredCredential;
    this.athorizationValidity = this.data.Entity.AthorizationValidity;
    if (this.athorizationValidity) {
      this.validityDays = "(" + this.data.Entity.AthorizationValidityDay + ")";
    } else {
      this.validityDays = "(" + this.data.Entity.MedicalOrderValidityDay + ")";
    }
    this.formGroup.valueChanges.subscribe((value) => {
      this.dataChange.emit({
        ...value
      });
    });

    this.loaded = true;
  }
}
